// CreateCard.jsx
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Box,
  Button,
} from "@mui/material";
import EntityMapped from "../entityMapped/EntityMapped";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState } from "react";

const CreateCard = ({ nombre, entidad }) => {
  const [showData, setShowData] = useState(true);
  return (
    <Card
      sx={{
        mb: 3,
        borderRadius: 4,
        boxShadow: 6,
        overflow: "hidden",
        background: "linear-gradient(145deg, #ffffff 0%, #f7f7f7 100%)",
      }}
    >
      <Box
        sx={{
          bgcolor: "rgb(36, 113, 163)",
          color: "white",
          py: 2,
          display: "flex",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Box
          onClick={() => setShowData(!showData)}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <KeyboardArrowDownIcon
            fontSize="medium"
            sx={{
              color: "white",
              transform: showData ? "rotate(0deg)" : "rotate(180deg)",
              transition: "transform 0.3s ease",
            }}
          />
        </Box>
        <Typography variant="h5" fontWeight="bold">
          {nombre}
        </Typography>
      </Box>

      <CardContent sx={{ p: 3, display: showData ? "none" : "block" }}>
        <Divider sx={{ mb: 2 }} />
        <EntityMapped entity={entidad} />
      </CardContent>
    </Card>
  );
};

export default CreateCard;
